export default __webpack_public_path__ + "static/bg-2-df500a712e1c8a7217ac543f35c0e017.png";